<template>
    <v-dialog
      v-model ="editdialogProp"
      persistent
      max-width="500"
    >
      <v-card class="pad-10">
        <!-- <v-card-title class=""> -->
          <p class="text-center"><b>Edit Trade </b></p>
          <p class="text-center font-weight-bold">*You are about <span class="red--text">editing</span> {{transaction.roomName}} Trade*</p>
        <!-- </v-card-title> -->
        
        <v-btn
            icon
            absolute
            top
            right
            @click="$emit('closeModal')"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        <v-card-text>
          <information-box
            :store="transaction.transaction.giftcard.store.name"
            :amount="previousAmount"
            :giftcard = "giftcardName"
            :rate = "transaction.transaction.giftcard.rate"
          />

          <label class="font-weight-medium" for="">Select New Giftcard</label>
          <v-select :items="giftcards" item-text="name" item-value="id" v-model="giftcard" outlined>
            <template v-slot:selection="{ item }">
                <img class="rounded mr-3" width="30" height="30" contain :src="item.icon" />{{ `${item.name} ${item.country.cca2}
                                (${item.country.currencySymbol}${item.cardMin}
                - ${item.country.currencySymbol}${item.cardMax}) - ${item.type}` }}
            </template>
            <template v-slot:item="{ item }">
                <img width="30" height="30" class="rounded mr-3" :src="item.icon">{{ `${item.name} ${item.country.cca2}
                                (${item.country.currencySymbol}${item.cardMin}
                - ${item.country.currencySymbol}${item.cardMax}) - ${item.type}` }}
            </template>
          </v-select>
          <label for="" class="font-weight-medium">Enter New Amount</label>
          <v-text-field placeholder="new amount" color="auto" v-model="newAmount" type="number" outlined></v-text-field>
          <br />
          <default-button :loading="loading" :disabled="!isComplete" @click="editTrade()">Edit Trade</default-button>
        </v-card-text>
      </v-card>
    </v-dialog>
</template>

<script>
// =============== IMPORT COMPONENT ==============
import DefaultButton from "@/components/Buttons/default-button.vue";
import InformationBox from "./information-box.vue"

// ================= IMPORT SERVICES ===============
import { StoresService } from "@/services";

export default {
    props:{
        editdialogProp:{
            type:Boolean,
        },
        transaction:{
          type:Object
        },
    },
    components: {
      DefaultButton,
      InformationBox
    },
    data: () => ({
      newAmount:null,
      loading: false,
      giftcards: [],
      giftcard:null
    }),
    computed:{
      isComplete() {
        return this.newAmount
      },
      previousAmount(){
            if(this.transaction.transaction.loaderAmount){
                return Number(this.transaction.transaction.loaderAmount)
            }
            else{
                return Number(this.transaction.transaction.userAmount)
            }
      },
      giftcardName() {
        return `${this.transaction.transaction.giftcard.name} ${this.transaction.transaction.giftcard.country.cca2} (${this.transaction.transaction.giftcard.country.currencySymbol}${this.transaction.transaction.giftcard.cardMin}
 - ${this.transaction.transaction.giftcard.country.currencySymbol}${this.transaction.transaction.giftcard.cardMax})`
        }
    },
    async mounted(){
      if(this.transaction.transaction){
        this.getGiftcards();
      }
      
      // this.store = this.transaction.transaction.store;
    },
    methods:{
      // ============ METHOD TO EDIT TRADE ===========
      async editTrade(){
        try {
          this.loading = true;
          let payload = {
            trade : this.transaction.roomId,
            amount : Number(this.newAmount),
            giftcard : this.giftcard
          }
          const data = await StoresService.editTrade(payload);
          this.loading = false;
          this.$emit('closeModal',data)
          this.newAmount = '';
        } catch (error) {
          this.loading = false
          console.log(error);
        }
      },

      // ============ METHOD TO LOAD GIFTCARDS ========
      async getGiftcards(){
        try{
          const data = await StoresService.loadGiftcards({
            store : this.transaction.transaction.giftcard.store.id
          })
          this.giftcards= data;
        } catch(error){
          console.log(error);
        }
      }
    },
    
  watch:{
  },
}
</script>

<style lang="scss" scoped>
@import './styles.scss'
</style>